import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PersonaTemplateItem {
  id: string;
  template_id: string;
  persona_profile_id: string;
  percentage: number;
  sessions_per_user_per_day: number;
  sort_order: number;
}

export interface PersonaTemplate {
  id: string;
  name: string;
  description: string;
  icon: string;
  recommended_for: string;
  total_users: number;
  is_active: boolean;
  items?: PersonaTemplateItem[];
}

export function usePersonaTemplates() {
  return useQuery({
    queryKey: ['persona-templates'],
    queryFn: async () => {
      // Fetch templates
      const { data: templates, error: templatesError } = await supabase
        .from('persona_templates')
        .select('*')
        .eq('is_active', true)
        .order('name');

      if (templatesError) throw templatesError;

      // Fetch template items
      const { data: items, error: itemsError } = await supabase
        .from('persona_template_items')
        .select('*')
        .order('sort_order');

      if (itemsError) throw itemsError;

      // Combine templates with their items
      const templatesWithItems = ((templates || []) as any[]).map(template => ({
        ...template,
        items: ((items || []) as any[]).filter((item: any) => item.template_id === template.id),
      }));

      return templatesWithItems as PersonaTemplate[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
